// =============================================================
// ALL DATA IN THIS FILE IS SOURCED FROM VERIFIED PUBLIC SOURCES:
//  1. https://shramikgroup.in (official website)
//  2. Shramik Milk & Food Processing Industries Introduction Letter
//     (Ref: SMFPI-2/BP/001/2024-25, dated 11/05/2024)
// No fabricated statistics, quotes, or names are used.
// =============================================================

export const VERTICALS = [
  {
    slug: "agriculture",
    name: "Shramik Krushi Seva Kendra",
    tag: "Agri-Inputs Trading & Advisory",
    short: "Authorised dealer of fertilizers, pesticides and certified seeds — backed by expert agronomic advisory since 1976.",
    image: "https://images.weserv.nl/?url=shramikgroup.in/img/banner2.jpg&w=1600",
    color: "from-emerald-800/70 to-emerald-500/20",
    highlights: ["Fertilizers", "Pesticides", "Certified Seeds", "Agronomy Advisory", "14 Branch Network"],
    body: "Shramik Krushi Seva Kendra is a leading agricultural input and advisory company dedicated to strengthening farm productivity and supporting sustainable rural development. As an authorised and trusted dealer of fertilizers, pesticides and certified seeds, we ensure farmers receive high-quality, research-backed products.",
    longBody: [
      "With decades of experience in the agriculture sector, we go beyond product supply by offering expert agronomic consultation tailored to local farming conditions. Our team provides guidance on nutrient management, pest and disease control, seed selection and best cultivation practices — helping farmers make precise, informed and profitable decisions.",
      "Driven by a commitment to transparency, service excellence and farmer empowerment, we continue to be a reliable partner for progressive and small-scale farmers alike.",
    ],
    established: "27 August 1976",
    address: "Shramik Pratisthan, Behind ST Stand, Sangamner – 422605, Ahilyanagar, Maharashtra",
    contact: "02425-225345, 225599",
    kpis: [{k:"Established", v:"1976"}, {k:"Branches", v:"14"}, {k:"Districts", v:"3"}],
    services: ["Fertilizers (authorised dealer)", "Pesticides & crop protection", "Certified seeds", "Agronomic consultation", "Nutrient management", "Pest & disease control"],
    branches: [
      { name: "Sangamner", addr: "Behind Bus Stand, Sangamner, Ahilyanagar – 422605", map: "https://maps.app.goo.gl/rZQ33pJNviPu3BU76" },
      { name: "Market Yard, Sangamner", addr: "Krishidhan Complex, Market Yard, Sangamner – 422605", map: "https://maps.app.goo.gl/wJEMceg93FFduYYt7" },
      { name: "Ashwi Bk.", addr: "Ashwi–Dhad Rd, Tal. Sangamner – 413714", map: "https://maps.app.goo.gl/wKiKPxydza9o4jRL7" },
      { name: "Dhandarphal Bk.", addr: "Near S R Navalepatil Petroleum, Sangamner–Akole Rd – 422603", map: "https://maps.app.goo.gl/RBKwETeUHqNDFiNK7" },
      { name: "Nimgaon Jali", addr: "Near S R Navalepatil Petroleum, Sangamner–Loni Rd – 413714", map: "https://maps.app.goo.gl/CVc17aFyes9SEgWn6" },
      { name: "Akole", addr: "Shramik Complex, Near Police HQ, Akole – 422604", map: "https://maps.app.goo.gl/k9am1ui2THHoevqz7" },
      { name: "Deolali Pravara", addr: "VKSS Shopping Complex, Tal. Rahuri – 413716", map: "https://maps.app.goo.gl/N9AdVc9P6RhLZtrd6" },
      { name: "Sakuri", addr: "H No. 448, Rahata–Sakuri Rd, Tal. Rahata – 424304", map: "https://maps.app.goo.gl/NDp2JMG7utBjoLwq8" },
      { name: "Shrirampur", addr: "Manik Complex, Near Central Bank, Shrirampur – 413715", map: "https://maps.app.goo.gl/LRhU21avwDjRtrXr7" },
      { name: "Ahilyanagar", addr: "Plot No. 94, Market Yard, Ahilyanagar – 414111", map: "https://maps.app.goo.gl/DXK977fcvXo52T6m6" },
      { name: "Narayangaon (Pune)", addr: "Bizzy Plaza Complex, Nashik–Pune Highway – 412412", map: "https://maps.app.goo.gl/u7dnfZknoiCgyCsu7" },
      { name: "Market Yard, Nashik", addr: "Nashik–Dindori Rd, Market Yard – 422003", map: "https://maps.app.goo.gl/s6YhCn5ywPEbe9mg9" },
      { name: "Pimpalgaon Baswant", addr: "Shop No. 5, Dulaji Nana Vyapari Sankul – 422009", map: null },
      { name: "Nashik Road", addr: "VKSS Shopping Center, Sinnar Phata, Deolali – 422001", map: "https://maps.app.goo.gl/P6fccXftW54PuGzs5" },
    ],
  },
  {
    slug: "dairy",
    name: "Shramik Milk & Food Processing Industry",
    tag: "Dairy & Food Processing",
    short: "A farmer-linked dairy enterprise processing 83,500+ litres daily with 72 collection centers and 4,500+ producer members.",
    image: "https://images.weserv.nl/?url=shramikgroup.in/img/Shramik.jpg&w=1600",
    color: "from-sky-800/70 to-sky-500/20",
    highlights: ["Toned Milk", "Standardized Milk", "Full Cream Milk", "Curd", "Chass", "Lassi", "Shrikhand", "Paneer", "Ghee"],
    body: "Shramik Milk and Food Processing Unit is a forward-looking dairy enterprise committed to delivering safe, nutritious and high-quality dairy products. Equipped with modern technology and stringent quality-control systems, we ensure every stage — from milk procurement to final packaging — meets industry standards for hygiene and purity.",
    longBody: [
      "We currently handle 80,000 litres of cow milk and 3,500 litres of buffalo milk every day — collected through 72 owned milk collection centers within a 20 km radius of the plant. More than 4,500 farmer families supply milk daily under a direct-payment system with zero third-party purchase.",
      "Every collection center is equipped with a milk testing lab, and daily payments go directly into farmers' bank accounts. Our farmer support programs include ~700 MT of cattle feed distributed monthly, veterinary services, fodder inputs, dairy equipment and government-subsidy-backed dairy tie-up loans.",
      "Current retail portfolio includes toned, standardized and full-cream milk (pouch), curd, chass, lassi, shrikhand, paneer and ghee. Milk quality is targeted at premium ingredient-grade — SNF ≥ 8.5, FAT ≥ 3.6, MBRT 90–180 min, antibiotic and aflatoxin negative.",
    ],
    established: "2015",
    address: "Dhandarphal Bk., Tal. Sangamner, Dist. Ahilyanagar – 422603",
    map: "https://maps.app.goo.gl/hgrvzSzdxy1kh6qv9",
    kpis: [{k:"Daily milk handled", v:"83,500 L"}, {k:"Collection centers", v:"72"}, {k:"Producer members", v:"4,500+"}],
    products: [
      { name: "Toned Milk (Pouch)", tag: "Milk" },
      { name: "Standardized Milk (Pouch)", tag: "Milk" },
      { name: "Full Cream Milk (Pouch)", tag: "Milk" },
      { name: "Curd (Pouch / Cup)", tag: "Curd" },
      { name: "Chass", tag: "Beverage" },
      { name: "Lassi / Shahi Lassi", tag: "Beverage" },
      { name: "Shrikhand", tag: "Sweet" },
      { name: "Paneer", tag: "Fresh" },
      { name: "Ghee", tag: "Ghee" },
    ],
    upcoming: [
      "30 TPD GEA Milk Powder Plant (SCADA)",
      "20 TPD Butter Plant",
      "10 KLPD Ice-cream Plant",
      "20 TPD Ghee Plant",
      "5 LLPD additional processing capacity",
      "6+ new own chilling centers",
    ],
    upcomingNote: "₹120 Crore capex program — 10,000 sq.m facility with SCADA-controlled processing, evaporator, dryer and HEPA-filtered powder packing. Vision: to become a premium ingredient supplier to nutraceutical & pediatric-nutrition manufacturers.",
  },
  {
    slug: "construction",
    name: "Shramik Stone Crusher & RMC",
    tag: "Aggregates & Construction Materials",
    short: "Quality-driven supplier of aggregates, sand and construction materials for infrastructure and development projects.",
    image: "https://images.weserv.nl/?url=shramikgroup.in/img/banner3.jpg&w=1600",
    color: "from-slate-800/70 to-slate-500/20",
    highlights: ["G.S.B", "40–60 mm Metal", "VSI Metal (6/10/20mm)", "Concrete Wash Sand", "Plaster Sand", "Dry Sand"],
    body: "Shramik Stone Crusher & RMC is a quality-driven unit supplying premium construction materials for infrastructure, commercial and residential projects. Equipped with modern crushing machinery, we manufacture high-grade aggregates, crushed stone and sand that meet stringent industry standards for strength, durability and consistency.",
    longBody: [
      "We offer G.S.B (Granular Sub Base), 40–60 mm metal; 6mm, 10mm and 20mm VSI metal; concrete wash sand, plaster sand and dry sand. Every batch is quality-tested to maintain precision and reliability.",
      "The unit is committed to sustainable practices, efficient resource management and safety-focused operations. With timely delivery, dependable service and a customer-centric approach, we aim to be a trusted partner for contractors, builders and infrastructure developers across the region.",
    ],
    established: "2024",
    address: "Pimple, Sangamner, Ahilyanagar, Maharashtra – 422611",
    kpis: [{k:"Established", v:"2024"}, {k:"Product grades", v:"8"}, {k:"Batches", v:"100% tested"}],
    products: [
      { name: "G.S.B (Granular Sub Base)", tag: "Base" },
      { name: "40–60 mm Metal", tag: "Aggregate" },
      { name: "6 mm VSI Metal", tag: "Aggregate" },
      { name: "10 mm VSI Metal", tag: "Aggregate" },
      { name: "20 mm VSI Metal", tag: "Aggregate" },
      { name: "Concrete Wash Sand", tag: "Sand" },
      { name: "Plaster Sand", tag: "Sand" },
      { name: "Dry Sand", tag: "Sand" },
    ],
  },
  {
    slug: "petroleum",
    name: "S R Navalepatil Petroleum",
    tag: "Fuel Retailing & EV",
    short: "Authorised Bharat Petroleum & Hindustan Petroleum outlets delivering reliable fuels, CNG and EV charging.",
    image: "https://images.weserv.nl/?url=shramikgroup.in/img/petrol.jpg&w=1600",
    color: "from-amber-700/70 to-amber-400/20",
    highlights: ["Petrol (MS)", "Diesel (HSD)", "CNG", "Speed Petrol", "60 KW EV Charging", "Nitrogen Tyre Air"],
    body: "S R Navalepatil Petroleum is a trusted and customer-focused fuelling organization offering reliable energy solutions. As an authorised operator of Bharat Petroleum and Hindustan Petroleum, we ensure the availability of completely pure fuels delivered through modern, safe and accurate dispensing systems.",
    longBody: [
      "Our facilities offer a full range of fuel options — petrol, diesel and CNG — along with Electric Vehicle (EV) Charging Stations, modern infrastructure and customer-centric service. With a focus on transparency, operational efficiency and adherence to regulatory guidelines, we aim to provide a dependable fuelling experience for private vehicles, commercial fleets and agricultural users.",
    ],
    established: "2020",
    kpis: [{k:"Outlets", v:"2"}, {k:"Brands", v:"BPCL & HPCL"}, {k:"EV Charging", v:"60 KW"}],
    services: [
      "Petrol (MS)", "Diesel (HSD)", "CNG", "Speed Petrol",
      "Automotive Lubricants", "60 KW EV Charging Station",
      "Free Nitrogen Tyre Air", "Tyre Service Station",
      "Accurate & Safe Fuel Dispensing", "Allied Agro-Service Center",
    ],
    outlets: [
      {
        name: "Dhandarphal",
        image: "https://images.weserv.nl/?url=shramikgroup.in/img/p1.jpg&w=1200",
        brand: "Bharat Petroleum",
        established: "2020",
        address: "Dhandarphal BK, Sangamner, Ahilyanagar – 422603",
        fuel: ["Petrol (MS)", "Diesel (HSD)", "CNG", "Speed Petrol"],
        vehicular: ["60 KW EV Charging Station", "Free Nitrogen Tyre Air", "Tyre Service Station"],
        consumer: ["Drinking Water", "Clean Toilets", "Food Station", "ATM with Cash Deposit", "Allied Agro-Service Center"],
      },
      {
        name: "Nimgaon Jali",
        image: "https://images.weserv.nl/?url=shramikgroup.in/img/p2.jpg&w=1200",
        brand: "Hindustan Petroleum",
        established: "2022",
        address: "Nimgaon Jali, Sangamner, Ahilyanagar – 413714",
        fuel: ["Petrol (MS)", "Diesel (HSD)"],
        vehicular: ["Free Tyre Air", "Tyre Service Station", "EV Charging Station"],
        consumer: ["Drinking Water", "Clean Toilets", "Food Station", "Allied Agro-Service Center"],
      },
    ],
    team: [
      { name: "Nilesh Pravin Landage", role: "Business Head", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/team-1.jpg&w=600" },
      { name: "Sanket Balasaheb Dengale", role: "General Manager", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/team-2.jpg&w=600" },
      { name: "Ganesh Bhausaheb Magar", role: "Facility Head", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/team-3.jpg&w=600" },
      { name: "Tukaram Dinkar Kokane", role: "Facility Head", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/team-4.jpg&w=600" },
    ],
  },
  {
    slug: "social",
    name: "Seva Sanskar Sanstha",
    tag: "Education & Rural Development",
    short: "Transforming rural education through the Shramshakti network of schools and colleges — including UG programs in Agriculture, Food Technology and Agricultural Engineering.",
    image: "https://images.weserv.nl/?url=shramikgroup.in/img/banner4.jpg&w=1600",
    color: "from-rose-800/70 to-rose-400/20",
    highlights: ["Shramshakti Schools", "Agriculture Polytechnic", "B.Sc. Agriculture", "B.Tech. Food Technology", "B.Tech. Agri Engineering", "Junior College"],
    body: "Seva Sanskar Sanstha is dedicated to transforming the educational landscape for rural students across Maharashtra. Through our network of Shramshakti Schools and Colleges, we offer affordable, high-quality education from kindergarten to higher secondary — plus specialised degree programs affiliated to Mahatma Phule Krishi Vidyapeeth, Rahuri.",
    longBody: [
      "Our mission is to provide opportunities for students who might not have access to quality education outside their communities. Under the guidance of Shramik Group, we are committed to nurturing local talent and empowering the next generation with practical knowledge and modern technical skills.",
      "The Trust also operates a rehabilitation and foster home for children — personally managed by our Founder Shri Sahebrao Ramchandra Navale for over 25 years. More than 50 children are currently in care, and over 2,500 past children have gone on to thrive in life.",
    ],
    address: "Maldad, Tal. Sangamner, Dist. Ahilyanagar – 422608",
    website: "https://sevasanskarsanstha.org.in/",
    kpis: [{k:"Institutions", v:"7"}, {k:"Foster home", v:"25 yrs"}, {k:"Children thrived", v:"2,500+"}],
    institutions: [
      { name: "Shramshakti Madyamik Vidyalaya", year: "1993" },
      { name: "Shramshakti College of Agriculture Polytechnic", year: "2000" },
      { name: "Shramshakti College of Agriculture", year: "2009" },
      { name: "Shramshakti College of Food Technology", year: "2009" },
      { name: "Shramshakti Vidyaniketan English Medium School", year: "2013" },
      { name: "Shramshakti College of Agricultural Engineering", year: "2014" },
      { name: "Shramshakti Junior College", year: "2023" },
    ],
  },
];

// Only leaders as listed on shramikgroup.in/team.php
export const LEADERSHIP = [
  { name: "Mr. Sahebrao R Navale Patil", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/sn.jpg&w=800&h=1000&fit=cover" },
  { name: "Mr. Bhaskarrao R Navale Patil", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/bn.jpg&w=800&h=1000&fit=cover" },
  { name: "Mr. Anil R Navale Patil", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/an1.jpg&w=800&h=1000&fit=cover" },
  { name: "Mr. Sanjay B Navale Patil", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/an2.jpg&w=800&h=1000&fit=cover" },
  { name: "Mr. Ajit S Navale Patil", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/an3.jpg&w=800&h=1000&fit=cover" },
  { name: "Mr. Amol B Navale Patil", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/an4.jpg&w=800&h=1000&fit=cover" },
  { name: "Dr. Amit S Navale Patil", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/an5.jpg&w=800&h=1000&fit=cover" },
  { name: "Mr. Aditya A Navale Patil", photo: "https://images.weserv.nl/?url=shramikgroup.in/img/an6.jpg&w=800&h=1000&fit=cover" },
];

// Only verified milestones from the Introduction Letter and website
export const MILESTONES = [
  { y: "1976", t: "Group Founded", d: "Founder Mr. Sahebrao Ramchandra Navale Patil establishes 'Agro Service Centre' — the beginning of what today is Shramik Krushi Seva Kendra." },
  { y: "1993", t: "Shramshakti Madyamik Vidyalaya", d: "First school of the education vertical begins operations." },
  { y: "2000", t: "Agriculture Polytechnic", d: "Shramshakti College of Agriculture Polytechnic established, affiliated to Mahatma Phule Krishi Vidyapeeth, Rahuri." },
  { y: "2009", t: "Two new colleges", d: "Shramshakti College of Agriculture and Shramshakti College of Food Technology are established." },
  { y: "2013", t: "English Medium School", d: "Shramshakti Vidyaniketan English Medium School begins operations." },
  { y: "2014", t: "Agricultural Engineering", d: "Shramshakti College of Agricultural Engineering established." },
  { y: "2015", t: "Milk Processing", d: "Shramik Milk and Food Processing Industry commissioned at Dhandarphal Bk." },
  { y: "2020", t: "Petroleum Retailing", d: "S R Navalepatil Petroleum begins operations as authorised Bharat Petroleum outlet at Dhandarphal." },
  { y: "2022", t: "HPCL Outlet", d: "Second fuel outlet opens at Nimgaon Jali as authorised Hindustan Petroleum partner." },
  { y: "2023", t: "Junior College", d: "Shramshakti Junior College is added to the Shramshakti institutions network." },
  { y: "2024", t: "Stone Crusher & RMC", d: "Shramik Stone Crusher & RMC unit commissioned at Pimple, Sangamner." },
];

// Only verified statistics from the Introduction Letter and website
export const IMPACT_STATS = [
  { label: "Founded (Group)", value: 1976, suffix: "", format: "year" },
  { label: "Krushi Seva Kendra Branches", value: 14, suffix: "" },
  { label: "Daily Milk Handled (Litres)", value: 83500, suffix: "+" },
  { label: "Own Milk Collection Centers", value: 72, suffix: "" },
  { label: "Producer Members", value: 4500, suffix: "+" },
  { label: "Educational Institutions", value: 7, suffix: "" },
];

export const WHY_CHOOSE = [
  { title: "Trusted by Farmers", d: "4,500+ farmer families supply milk daily; 14 KSK branches supply inputs since 1976.", icon: "Sprout" },
  { title: "Diversified Operations", d: "Vertically integrated across agri-inputs, dairy, mining, petroleum and education.", icon: "Factory" },
  { title: "Direct Farmer Payment", d: "Every collection center has a testing lab; payments go directly to farmers' bank accounts.", icon: "ShieldCheck" },
  { title: "Zero Third-Party Purchase", d: "100% own-network milk procurement within a 20 km radius of the plant.", icon: "Leaf" },
  { title: "Farmer Support", d: "~700 MT cattle feed / month, veterinary care, fodder inputs and dairy tie-up loans.", icon: "Users" },
  { title: "Modern Infrastructure", d: "SCADA-controlled dairy plant, 6 × 100 KL silos, GEA-supplied powder plant on order.", icon: "Truck" },
];

// Verified images from shramikgroup.in only
export const HERO_SLIDES = [
  { image: "https://images.weserv.nl/?url=shramikgroup.in/img/banner2.jpg&w=1900", label: "Agriculture", title: "Rooted in the Soil.", subtitle: "Empowering farmers with quality inputs and advisory since 1976." },
  { image: "https://images.weserv.nl/?url=shramikgroup.in/img/Shramik.jpg&w=1900", label: "Dairy", title: "83,500 Litres of Milk. Every Day.", subtitle: "72 collection centers, 4,500+ producer members, direct payments." },
  { image: "https://images.weserv.nl/?url=shramikgroup.in/img/banner3.jpg&w=1900", label: "Construction", title: "Building Tomorrow's Infrastructure.", subtitle: "Quality-tested aggregates and construction materials." },
  { image: "https://images.weserv.nl/?url=shramikgroup.in/img/petrol.jpg&w=1900", label: "Petroleum", title: "Reliable Energy, Every Kilometre.", subtitle: "Authorised BPCL & HPCL outlets with EV fast-charging." },
  { image: "https://images.weserv.nl/?url=shramikgroup.in/img/banner4.jpg&w=1900", label: "Education", title: "Rural Learning, Modern Skills.", subtitle: "7 Shramshakti institutions — schools, junior college and 4 degree colleges." },
];

// Projects — mix of operating units and confirmed upcoming projects from the Introduction Letter
export const PROJECTS = [
  {
    id: "p1",
    title: "Shramik Milk & Food Processing Plant, Dhandarphal",
    category: "Dairy",
    year: "2015",
    location: "Dhandarphal Bk., Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/Shramik.jpg&w=1600",
    d: "Farmer-linked dairy plant processing 83,500 L of milk daily — producing pouch milk, curd, chass, lassi, shrikhand, paneer and ghee.",
  },
  {
    id: "p2",
    title: "BPCL Fuel Station, Dhandarphal",
    category: "Infrastructure",
    year: "2020",
    location: "Dhandarphal BK, Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/p1.jpg&w=1600",
    d: "Authorised Bharat Petroleum outlet with Petrol, Diesel, CNG, Speed Petrol, 60 KW EV Charging Station and full traveller amenities.",
  },
  {
    id: "p3",
    title: "HPCL Fuel Station, Nimgaon Jali",
    category: "Infrastructure",
    year: "2022",
    location: "Nimgaon Jali, Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/p2.jpg&w=1600",
    d: "Authorised Hindustan Petroleum outlet with Petrol, Diesel, EV Charging Station, tyre service and Allied Agro-Service Center.",
  },
  {
    id: "p4",
    title: "Shramik Stone Crusher & RMC Unit, Pimple",
    category: "Infrastructure",
    year: "2024",
    location: "Pimple, Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/banner3.jpg&w=1600",
    d: "Modern crushing facility producing G.S.B, 40–60 mm metal, VSI metal (6/10/20 mm) and multiple grades of sand.",
  },
  {
    id: "p5",
    title: "Krushi Seva Kendra — 14 Branch Network",
    category: "Agriculture",
    year: "1976 – Present",
    location: "Ahilyanagar • Nashik • Pune",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/banner2.jpg&w=1600",
    d: "14 branches across three districts supplying fertilizers, certified seeds, pesticides and agronomic advisory.",
  },
  {
    id: "p6",
    title: "Shramshakti Institutions Network",
    category: "Community Development",
    year: "1993 – 2023",
    location: "Maldad, Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/banner4.jpg&w=1600",
    d: "Seven Shramshakti institutions spanning secondary school, English-medium school, junior college and 4 degree colleges (Agriculture, Food Tech, Agri Engineering, Polytechnic).",
  },
  // Upcoming — from Introduction Letter (₹120 Cr expansion)
  {
    id: "up1",
    title: "30 TPD Milk Powder Plant (GEA, SCADA)",
    category: "Upcoming",
    year: "Upcoming",
    location: "Dhandarphal Bk., Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/Shramik.jpg&w=1600",
    d: "Fully automatic SCADA-operated 30 TPD milk powder plant supplied by GEA — with 5-stage evaporator, dryer and CIP system.",
    upcoming: true,
  },
  {
    id: "up2",
    title: "20 TPD Butter Plant",
    category: "Upcoming",
    year: "Upcoming",
    location: "Dhandarphal Bk., Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/single.jpg&w=1600",
    d: "New 20 TPD butter plant — unsalted butter, lactic butter and (Phase-2) salted butter and AMF.",
    upcoming: true,
  },
  {
    id: "up3",
    title: "10 KLPD Ice-cream Plant",
    category: "Upcoming",
    year: "Upcoming",
    location: "Dhandarphal Bk., Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/single.jpg&w=1600",
    d: "10 KLPD ice-cream plant — cups, cones, sticks, tubs and kulfi.",
    upcoming: true,
  },
  {
    id: "up4",
    title: "20 TPD Ghee Plant",
    category: "Upcoming",
    year: "Upcoming",
    location: "Dhandarphal Bk., Sangamner",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/single.jpg&w=1600",
    d: "Bulk and consumer ghee — new 20 TPD ghee plant as part of the ingredient-supplier expansion.",
    upcoming: true,
  },
  {
    id: "up5",
    title: "6+ New Milk Chilling Centers",
    category: "Upcoming",
    year: "Upcoming",
    location: "50 km radius of Dhandarphal",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/banner2.jpg&w=1600",
    d: "Own chilling centers to unlock an additional 400 KL milk per day, expanding procurement radius and cold-chain reach.",
    upcoming: true,
  },
  {
    id: "up6",
    title: "Animal-Level Milk Traceability",
    category: "Upcoming",
    year: "Upcoming",
    location: "Dhandarphal producer network",
    img: "https://images.weserv.nl/?url=shramikgroup.in/img/post-1.jpg&w=1600",
    d: "Online technological setup for milk traceability all the way down to the animal level — enabling 100% own cow-milk collection with premium quality parameters.",
    upcoming: true,
  },
];

// Gallery uses only Shramik Group's own image assets
export const GALLERY = [
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/banner2.jpg&w=1400", cat: "Agriculture" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/Shramik.jpg&w=1400", cat: "Dairy" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/banner3.jpg&w=1400", cat: "Construction" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/p1.jpg&w=1400", cat: "Petroleum" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/p2.jpg&w=1400", cat: "Petroleum" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/petrol.jpg&w=1400", cat: "Petroleum" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/banner4.jpg&w=1400", cat: "Education" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/banner5.jpg&w=1400", cat: "Education" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/shramik1.jpg&w=1400", cat: "Group" },
  { src: "https://images.weserv.nl/?url=shramikgroup.in/img/shramik2.jpg&w=1400", cat: "Group" },
];

export const BRANCHES = [
  "Sangamner", "Market Yard Sangamner", "Ashwi Bk.", "Dhandarphal Bk.", "Nimgaon Jali",
  "Akole", "Deolali Pravara", "Sakuri", "Shrirampur", "Ahilyanagar",
  "Narayangaon (Pune)", "Market Yard Nashik", "Pimpalgaon Baswant", "Nashik Road",
];

export const CONTACT = {
  phone: "+91 74477 58899",
  phoneRaw: "917447758899",
  tel: "02425-225599",
  fax: "225099",
  email: "info@shramikgroup.in",
  address: "Shramik Pratishthan, At. Post & Taluka Sangamner, Dist. Ahilyanagar – 422605, Maharashtra",
  operations: "Dhandarphal Bk., Tal. Sangamner, Dist. Ahilyanagar – 422603",
};
